<nav class="navbar navbar-expand-lg bg-primary">
  <div class="container-fluid">
    <a class="navbar-brand font-eb-garamond" href="#">
      <img src="dragon-head-64.svg" class="d-none d-lg-inline-block d-inline-block align-text-top" alt="Wyvern">
      WYVERN WEAPONRY
    </a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
      <ul class="navbar-nav mb-2 mb-lg-0">
        @for (nav of navBar; track $index) {
          <li class="nav-item">
            <a class="nav-link btn" (click)="navigate(nav.navLink)">{{ nav.header }}</a>
          </li>
        }
        <li *ngIf="!isCartEmpty()" class="nav-item">
          <a class="nav-link btn" (click)="navigate('/cart')">Cart</a>
        </li>
        <li *ngIf="!isAuthenticated()" class="nav-item">
            <a class="nav-link btn" (click)="navigate('/login')">Login</a>
        </li>
        <!-- <li *ngIf="isAuthenticated()" class="nav-item">
          <a class="nav-link btn" (click)="logout()">Logout</a>
        </li> -->
        <li *ngIf="isAuthenticated()" class="nav-item dropdown">
          <a class="nav-link dropdown-toggle btn" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Account
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
            <li><a class="dropdown-item" (click)="navigate('/user')">Order History</a></li>
            <li *ngIf="isAdmin()"><a class="dropdown-item" (click)="navigate('/admin')">Admin Dashboard</a></li>
            <li><hr class="dropdown-divider"></li>
            <li><a class="dropdown-item" (click)="logout()">Logout</a></li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</nav>
@if(showBanner()) {
  <div id="carouselExampleCaptions" class="carousel slide p-0">
    <div class="carousel-inner">
      <div class="carousel-item active">
        <img src="range-test-img.jpg" class="d-block w-100 crop" alt="...">
        <div class="carousel-caption d-none d-md-block font-size-56">
          LIVE NOT IN FEAR
        </div>
      </div>
    </div>
  </div>
}
